import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=98433f16"
import script from "./welcome.ts?vue&type=script&lang=ts&external"
export * from "./welcome.ts?vue&type=script&lang=ts&external"
import style0 from "./welcome.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports